import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bslist-group',
	templateUrl:'./BSListGroupPage.html',
	styles: [],
	styleUrls:['./BSListGroupPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSListGroupPage
{
	mdContent_121 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.listgroup.BSListGroup;
\`\`\``;
	mdContent_122 = `\`\`\`java
new BSListGroup<>()
\`\`\``;
	mdContent_123 = `\`\`\`java
var list = new BSListGroup<>();
list.add(new BSListGroupListItem<>().setText("Item 1"));
list.add(new BSListGroupListItem<>().setText("Item 2"));
list.add(new BSListGroupListItem<>().setText("Item 3"));
\`\`\``;
}
